/**
 * Smaller-than-Cloudscape-Header layout for nested sub-sub-cards (e.g.,
 * carve-out rows inside C6). Cloudscape's Header only supports h1/h2/h3 —
 * this gives us a deeper hierarchy without leaving Cloudscape primitives
 * inside (Box for text + Badge for actions).
 */
import type { ReactNode } from "react";
import { Box, SpaceBetween } from "@cloudscape-design/components";

export function SubcardHeader({
  title,
  actions,
  status,
}: {
  title: ReactNode;
  actions?: ReactNode;
  /** Pinned to the far-right edge, after the action cluster — used for the
   *  Open/Done badge so it lines up as a scannable status column across cards. */
  status?: ReactNode;
}) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 12,
        minWidth: 0,
      }}
    >
      <div style={{ minWidth: 0, flex: 1, overflow: "hidden" }}>
        <Box variant="strong" fontSize="body-m">
          <span
            style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", display: "block" }}
          >
            {title}
          </span>
        </Box>
      </div>
      {actions && (
        // #99: this header sits inside an ExpandableSection header, so a click on
        // an action button (Edit / delete pencil) bubbles up and toggles the
        // section — collapsing the card. Stop propagation here so header buttons
        // never expand/collapse.
        <div style={{ flexShrink: 0 }} onClick={(e) => e.stopPropagation()}>
          <SpaceBetween direction="horizontal" size="xs">
            {actions}
          </SpaceBetween>
        </div>
      )}
      {status && (
        <div style={{ flexShrink: 0 }} onClick={(e) => e.stopPropagation()}>
          {status}
        </div>
      )}
    </div>
  );
}
